import { Link, useLocation } from 'react-router-dom';

// Map route segments to readable labels
const labelMap: Record<string, string> = {
  finance: 'Finance',
  journal: 'Journal',
  transactions: 'Transactions',
  coa: 'Chart of Accounts',
  reports: 'Reports',
  reconciliation: 'Reconciliation',
  orders: 'Orders',
  customers: 'Customers',
  products: 'Products',
  inventory: 'Inventory',
  admin: 'Admin',
  import: 'Import',
  audit: 'Audit Log',
  users: 'Users',
  settings: 'Settings',
  workshop: 'Workshop',
  spools: 'Filament & Spools',
  'print-queue': 'Print Queue',
  maintenance: 'Maintenance',
  printers: 'Printers',
  profile: 'Profile',
};

// Parent sections that don't have their own page (no direct route)
// These should be displayed as text only, not as clickable links
const nonClickablePaths = ['/workshop', '/finance', '/orders', '/admin'];

export function Breadcrumb() {
  const location = useLocation();
  
  // Parse pathname into breadcrumb parts
  const pathParts = location.pathname.split('/').filter(Boolean);
  
  // Build breadcrumb items with paths
  const breadcrumbs = pathParts.map((part, index) => {
    const path = '/' + pathParts.slice(0, index + 1).join('/');
    const label = labelMap[part] || part.charAt(0).toUpperCase() + part.slice(1);
    const isClickable = !nonClickablePaths.includes(path);
    return { path, label, isLast: index === pathParts.length - 1, isClickable };
  });

  // Don't show breadcrumb if we're at root
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center gap-2 text-sm text-slate-600 mb-4">
      <Link
        to="/"
        className="hover:text-slate-900 transition-colors"
      >
        Home
      </Link>
      
      {breadcrumbs.map((crumb) => (
        <div key={crumb.path} className="flex items-center gap-2">
          <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          
          {crumb.isLast || !crumb.isClickable ? (
            <span className={crumb.isLast ? 'text-slate-900 font-medium' : 'text-slate-600'}>
              {crumb.label}
            </span>
          ) : (
            <Link
              to={crumb.path}
              className="hover:text-slate-900 transition-colors"
            >
              {crumb.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
}
